export default "__VITE_ASSET__83877f5a__"